import { render, staticRenderFns } from "./pc_pick.vue?vue&type=template&id=1f09bf82&scoped=true&"
import script from "./pc_pick.vue?vue&type=script&lang=js&"
export * from "./pc_pick.vue?vue&type=script&lang=js&"
import style0 from "./pc_pick.vue?vue&type=style&index=0&id=1f09bf82&scoped=true&lang=less&"
import style1 from "./pc_pick.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f09bf82",
  null
  
)

export default component.exports